import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const breadcrumbsItem = (theme: Theme) => css`
  display: flex;
  align-items: center;
  white-space: nowrap;

  /* Crumb separator */
  &:not(:first-of-type) {
    margin-left: ${size[8]};

    ${breakpoint.up('sm')} {
      margin-left: ${size[12]};
    }

    &::before {
      content: '';
      margin-right: ${size[8]};
      border-right: 1px solid ${theme.palette.neutral[600]};
      transform: rotate(20deg);
      height: ${size[12]};
      border-radius: ${size[8]};

      ${breakpoint.up('sm')} {
        margin-right: ${size[12]};
      }
    }
  }

  /* Underline except for last crumb */
  &:not(:last-of-type):hover {
    text-decoration: underline ${theme.palette.neutral[600]};
  }
`

export const link = css`
  text-decoration: none;
`
